var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-chart',{attrs:{"id":this.id,"chartType":_vm.chartType,"chartData":_vm.chartData,"chartConfig":_vm.chartConfig,"chartSettings":_vm.chartSettings,"chartExtend":_vm.chartExtend,"loading":_vm.loading,"chartEvents":_vm.chartEvents,"extraToolbox":_vm.extraToolbox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }